import { expandFontTheme, theme } from '@contrast-security-inc/design-system-foundations';
import { css, cx } from '@emotion/css';
import mergeRefs from 'merge-refs';
import React, { forwardRef, useRef } from 'react';
import { MenuContext } from './MenuContext';
const menuItemStyle = css `
  display: block;
  border: none;
  width: 100%;
  background-color: unset;
  text-align: start;
  margin: 0;
  cursor: pointer;
  padding: 12px 16px;
  ${expandFontTheme(theme.font.body)};
  color: ${theme.color.neutral100};

  :focus {
    outline: none;
  }
`;
const menuItemHighlightedStyle = css `
  background-color: ${theme.color.teal10};
`;
const menuItemDisabledStyle = css `
  opacity: 0.4;
  cursor: not-allowed;
`;
export const MenuItem = forwardRef(({ className, index, children, disabled, onClick, onKeyDown, testId, ...rest }, ref) => {
    const { getItemProps, highlightedIndex } = React.useContext(MenuContext);
    const buttonRef = useRef(null);
    const { isHighlighted, ...itemProps } = getItemProps?.(index ?? 0, { onClick, onKeyDown }) ?? {
        ref: undefined,
        onClick,
        onKeyDown: undefined,
    };
    return (React.createElement("button", { key: index, ...rest, ...itemProps, "data-testid": testId, role: "menuitem", ref: mergeRefs(itemProps?.ref, buttonRef, ref), onClick: (event) => {
            itemProps?.onClick?.(event);
        }, disabled: disabled, onKeyDown: (event) => {
            itemProps?.onKeyDown?.(event);
        }, className: cx(menuItemStyle, {
            [menuItemHighlightedStyle]: highlightedIndex === index,
            [menuItemDisabledStyle]: disabled,
        }, className, 'ds-menu-item'), type: "button" }, typeof children === 'function' ? children({ ...itemProps, isHighlighted }) : children));
});
MenuItem.displayName = 'MenuItem';
